export default function (data, parent, field) {
  var self = this;
  var r = Kadenze.Util.objFromString;
  var $container;
  var default_er = null;
  var name = null;

  self.field_ref = ko.observable(field);
  self.id = ko.observable(r(data, 'id', null));
  self.dom_id = ko.observable('gc-' + (self.id() || 'new-' + _.random(100)));
  self.coursework_id = ko.computed(function() {
    return r(data, 'coursework_id', parent.coursework() ? parent.coursework().id() : null);
  });
  self.is_draft_course = ko.computed(function() {
    return parent.coursework() ? (parent.coursework().course.is_draft()) : false;
  });
  self.max_assessment_count = ko.computed(function() {
    return parent.coursework() ? (parent.coursework().student_count() - 1) : 0;
  });
  self.coursework_field_id = ko.computed(function() {
    return r(data, 'coursework_field_id', field ? field.id() : null);
  });
  self.scope = ko.observable(r(data, 'scope', 'instructor'));
  if (self.scope() == 'assessment') {
    name = 'Peer Assessment';
  } else if (self.scope() == 'peer') {
    default_er = {value: true, notes: false};
  } else if (self.scope() == 'gallery') {
    name = 'Gallery Participation';
    default_er = {global: {coursework_id: parent.coursework() && _.any(parent.coursework().coursework_fields(), function (field) { return field.gallery(); }) ? self.coursework_id() : null}};
  } else if (self.scope() == 'forum') {
    name = 'Forum Participation';
    default_er = {global: {coursework_id: parent.coursework() && parent.coursework().forum_settings.enabled() ? self.coursework_id() : null}, commenting: {required_count: null, min_word_length: null, deadline: null, allow_self_commenting: false},
      posting: {required_count: null, min_word_length: null}};
  } else if (self.scope() == 'completion') {
    name = 'Completion Assessment';
  }
  self.name = ko.observable(r(data, 'name', name)).extend({required: true });
  var current_er = r(data, 'entry_requirements', {});
  self.entry_requirements = ko.observable(ko.mapping.fromJS(_.extend({}, default_er, current_er)));

  //Participation coursework validation
  if (self.entry_requirements().global && self.entry_requirements().global.coursework_id) {
    self.entry_requirements().global.coursework_id.subscribeChanged(function (newValue, oldValue) {
      if (self.scope() === 'forum' && newValue === self.coursework_id() && !parent.coursework().forum_settings.enabled()) {
        Kadenze.UIUtil.confirmAction('It looks like you haven\'t enabled a forum for this coursework yet on Step 1, would you like to do that now?', function () {
          parent.coursework().forum_settings.enabled(true);
        }, function () {
          self.entry_requirements().global.coursework_id(oldValue);
        }, {
          title: 'Uh Oh'
        });
      } else if (self.scope() === 'gallery' && newValue === self.coursework_id() && !_.any(parent.coursework().coursework_fields(), function (field) { return field.gallery(); })) {
        Kadenze.UIUtil.confirmAction('It looks like there are no fields available in the course gallery for this coursework. Please add a field for the gallery on Step 3 before selecting \'This coursework\' option. Would you like to do that now?', function () {
          parent.wizard.nextPage();
        }, function () {
          self.entry_requirements().global.coursework_id(oldValue);
        }, {
          title: 'Uh Oh'
        });
      }
    });
  }
    
  self.numerical_assessment_required = ko.computed({
    read: function() {
      var required = true;
      if (self.scope() == 'peer') {
        required = !_.isEmpty(self.entry_requirements()) && self.entry_requirements().value() === true;
      }
      return required;
    },
    write: function(value) {
      self.entry_requirements().value(value);
    }
  });
  self.numerical_assessment_required.subscribe(function() {
    if (!self.numerical_assessment_required()) {
      self.points(null);
      self.weight(null);
    }
  });
  self.written_feedback_required = ko.computed({
    read: function() {
      var required = false;
      if (self.scope() == 'peer') {
        required = !_.isEmpty(self.entry_requirements()) && self.entry_requirements().notes() === true;
      }
      return required;
    },
    write: function(value) {
      self.entry_requirements().notes(value);
    }
  });
  self.disable_editing = ko.computed(function() {
    var disabled = false;
    if ((self.scope() == 'peer' || self.scope() == 'assessment') && (parent.coursework() ? parent.coursework().peer_assessments_begun() : false)) {
      disabled = true;
    } else if (self.scope() == 'gallery' && (parent.coursework() ? parent.coursework().gallery_participation_assessments_begun() : false)) {
      disabled = true;
    } else if (self.scope() == 'forum' && (parent.coursework() ? parent.coursework().forum_participation_assessments_begun() : false)) {
      disabled = true;
    }
    return disabled;
  });
  self.assessment_category_selected = ko.computed(function() {
    return (self.numerical_assessment_required() || self.written_feedback_required());
  }).extend({ equal: {param: true, message: 'Please select at least one assessment category'} });
  self.description = ko.observable(r(data, 'description', null));
  self.notes = ko.observable(r(data, 'notes', null));
  self.points = ko.observable(r(data, 'points', self.numerical_assessment_required() ? 0 : null)).extend({
    required: self.numerical_assessment_required,
    min: _.includes(['completion','assessment','gallery','forum','instructor'], self.scope()) ? 1 : 0,
    defaultValue: _.includes(['completion'], self.scope()) ? 1 : (self.numerical_assessment_required() ? 0 : null)
  });
  self.points.subscribe(function() {
    if (_.isNumber(self.id())) {
      if (self.scope() == 'assessment' && self.points() == 0) {
        if (parent.hasCriteriaWithScope('peer')) {
          new Kadenze.Notice.error($.extend({}, {message: 'Please remove assessment criteria first if you want to disable peer assessments.'}));
          return;
        }
        Kadenze.UIUtil.confirmAction('Are you sure you want to disable peer assessment in this coursework?', function () {
          self._destroy(true);
          var response = parent.save($container);
          response.error(function (xhr, textStatus, errorThrown) {
            new Kadenze.Notice.error($.extend({}, parent.defaultNoticeOptions, {message: xhr.responseJSON.errors}));
          });
        });
      } else if (_.includes(['gallery', 'forum'], self.scope()) && self.points() == 0) {
        var msg = 'Are you sure you want to disable {scope} participation assessment in this coursework?'.supplant({scope: self.scope()});
        Kadenze.UIUtil.confirmAction(msg, function () {
          self._destroy(true);
          var response = parent.save($container);
          response.error(function (xhr, textStatus, errorThrown) {
            new Kadenze.Notice.error($.extend({}, parent.defaultNoticeOptions, {message: xhr.responseJSON.errors}));
          });
        });
      }
    }
  });
  self.maxWeight = ko.computed(function() {
    var unused = 100 - parent.totalCriteriaWeight();
    var max = (self.weight ? parseFloat(self.weight() || 0) : 0) + unused;
    return Math.max(0, max).toString();
  });
  self.extra_credit = ko.observable(r(data, 'extra_credit', false));
  self.weight = ko.observable(r(data, 'weight', self.numerical_assessment_required() ? 0 : null)).extend({
    required: self.numerical_assessment_required,
    min: 0,
    max: { params: self.maxWeight, onlyIf: function() { return !self.extra_credit(); } },
    defaultValue: self.numerical_assessment_required() ? 0 : null
  });
  self.auto_grader_id = ko.computed(function() {
    return field ? field.auto_grader_id() : r(data, 'auto_grader_id', null);
  });
  self.ag_feature_id_org = ko.observable(r(data, 'ag_feature_id', null));
  self.ag_parameters = ko.mapping.fromJS(r(data, 'ag_parameters', []));
  self.ag_feature_id = ko.computed({
    read: function() {
      return self.ag_feature_id_org();
    },
    write: function(value) {
      if (!_.isUndefined(value)) {
        self.ag_feature_id_org(value);
        self.setupAGParams();
      }
    }
  });

  self.editing = ko.observable(r(data, 'editing', false)); //This will keep the question panel open if true
  self._destroy = ko.observable(r(data, '_destroy', false));

  self.keysToWatch = ['name', 'description', 'points', 'weight', 'extra_credit'];
  self.snapshot = {};

  self.calcForumParticiaptionPoints = function() {
    var required_posts = self.entry_requirements().posting.required_count() || 0;
    var required_comments = self.entry_requirements().commenting.required_count() || 0;
    var total = required_posts + required_comments;
    self.points(total);
  };

  switch (self.scope()) {
  case 'instructor':
    $container = parent.$instCriteriaContainer;
    break;
  case 'peer':
  case 'assessment':
    $container = parent.$peerCriteriaContainer;
    break;
  case 'gallery':
    $container = parent.$galleryParticipationCriteriaContainer;
    break;
  case 'forum':
    $container = parent.$forumParticipationCriteriaContainer;
    self.entry_requirements().posting.required_count.subscribe(self.calcForumParticiaptionPoints);
    self.entry_requirements().commenting.required_count.subscribe(self.calcForumParticiaptionPoints);
    break;
  case 'autograder':
    $container = $('#js-cw-step3');
    break;
  }

  self.setupAGParams = function() {
    self.ag_parameters([]);
    if (self.auto_grader_id() && self.ag_feature_id()) {
      var criterion = self.field_ref().getAutoGraderCriterion(self.auto_grader_id(), self.ag_feature_id());
      if (typeof criterion[0]['parameters'] != 'undefined') {
        var params = criterion[0]['parameters'];
        $(params).each(function(index, param) {
          var ag_param = {
            name: param.name,
            param_id: param.param_id,
            value: '',
            type: param.type
          };
          if (param.options) {
            ag_param.options = param.options;
          }
          self.ag_parameters.push(ko.mapping.fromJS(ag_param));
        });
      } else {
        self.ag_parameters([]);
      }
    }
  };

  self.autoGraderCriteria = ko.computed(function() {
    console.log('autoGraderCriteria called');
    console.log(self.field_ref());
    console.log(self.field_ref() && self.field_ref().available_criteria() || []);
    return self.field_ref() && self.field_ref().available_criteria() || [];
  }); 

  self.autoGraderCriteria.subscribe(function() {
    // hack to avoid knockout binding race condition
    setTimeout(function() { 
      console.log('notifying feature id subscribers');
      self.ag_feature_id.notifySubscribers(); 
    }, 300
    );
  });

  self.injectAGParamValues = function() {
    if (self.ag_parameters()) {
      _.each(self.ag_parameters(), function(param) {
        if (typeof param.value == 'undefined') {
          param.value = ko.observable('');
        }
      });
    }
  };

  self.takeSnapshot = function() {
    //TODO: Fix entry_requirements snap-shooting
    _.each(self.keysToWatch, function(key) { self.snapshot[key] = _.isObject(self[key]()) ? self[key]().toString() : self[key](); });
  };

  self.restoreSnapshot = function() {
    _.each(self.keysToWatch, function(key) {
      if (_.has(self.snapshot, key))
        self[key](self.snapshot[key]);
    });
  };

  self.resetSnapshot = function() {
    self.snapshot = {};
  };

  self.findObservables = function (obj) {
    //Recursively find deep nested observables
    var observables = [];
    _.each(_.values(obj), function (val) {
      if (ko.isObservable(val)) {
        observables.push(val);
      } else if (_.isObject(val)) {
        _.each(self.findObservables(val), function (o) {
          observables.push(o);
        });
      }
    });
    return observables;
  };

  self.validate = function() {
    var propsToValidate = [];
    _.each(Object.getOwnPropertyNames(self), function(key) {
      if (ko.isObservable(self[key])) {
        /*if (_.isObject(self[key]())) {
           var obj = self[key]();
           _.each(self.findObservables(obj), function (o) {
           propsToValidate.push(o);
           });
           } else {
           propsToValidate.push(self[key]);
           }*/
        propsToValidate.push(self[key]);
      }
    });

    var errors = ko.validation.group(propsToValidate);
    errors.showAllMessages(true);
    return errors();
  };

  self.isValid = function () {
    return self.validate().length == 0;
  };

  self.initEditorUI = function() {
    Kadenze.UIUtil.initExpandableTextareas();
  };

  self.toggleEditor = function() {
    if (!self.editing()) {
      self.takeSnapshot();
      self.initEditorUI();
    }
    var $row = $('#' + self.dom_id());
    var $editRow = $('.display-table__edit_row', $row);
    $row.toggleClass('collapsed');
    $row.toggleClass('expanded');
    $editRow.collapse('toggle');
    self.editing(!self.editing());
  };

  self.destroy = function(item, event) {
    var destroyThis = function () {
      self._destroy(true);
      var response = parent.save($container);
    };
    if (self.scope() == 'completion') {
      destroyThis();
    } else {
      Kadenze.UIUtil.confirmAction('Are you sure you want to delete this criterion?', function() {
        destroyThis();
      });
    }

    if (event)
      event.stopPropagation();
  };

  self.add = function(item, event) {
    if (item.isValid()) {
      parent.coursework().grading_criteria.push(item);
      var response = parent.save($container);
      response.success(function() {
        parent.newCriteria(false);
      });
      response.error(function (xhr, textStatus, errorThrown) {
        parent.coursework().grading_criteria.pop();
        new Kadenze.Notice.error($.extend({}, parent.defaultNoticeOptions, { message: xhr.responseJSON.errors }));
      });
    }
  };

  self.addToField = function(item, event) {
    if (item.isValid()) {
      field.grading_criteria.push(item);
      var response = parent.save($container);
      response.success(function() {
        parent.newCriteria(false);
      });
      response.error(function (xhr, textStatus, errorThrown) {
        field.grading_criteria.pop();
        new Kadenze.Notice.error($.extend({}, parent.defaultNoticeOptions, { message: xhr.responseJSON.errors }));
      });
    }
  };

  self.update = function(item, event) {
    if (self.isValid()) {
      var response = parent.save($container);
      response.success(function() {
        self.resetSnapshot();
      });
      response.error(function (xhr, textStatus, errorThrown) {
        new Kadenze.Notice.error($.extend({}, parent.defaultNoticeOptions, { message: xhr.responseJSON.errors }));
      });
    }
  };

  self.cancel = function(item, event) {
    if (parent.newCriteria() && (parent.newCriteria().scope() == item.scope())) {
      parent.newCriteria(false);
    } else {
      self.restoreSnapshot();
      self.toggleEditor();
    }
  };

  // If for some reason a value attr didn't get saved inside one of the ag_parameters,
  // inject a value observable during run-time to prevent breaking the UI
  self.injectAGParamValues();

  return self;
}

